<div
  #grid
  ngGrid
  mibCard
  padding="none"
  [attr.aria-label]="ariaLabel()"
  [class]="gridClasses()"
  [style.grid-template-columns]="tracks()"
  [style.max-height]="outerHeight()">
  @if (!headless()) {
    <div
      ngGridRow
      mibClipped
      #headingTip="mibClipped"
      [class]="headingRowClasses()"
      [mibTooltip]="headingTip.clipped()"
      [mibTooltipShowDelay]="tooltipDelay">
      @for (column of columns(); track $index) {
        <div ngGridCell role="columnheader" [class]="cellClasses(column)">
          <span class="min-w-0 truncate">{{ column.label ?? '' }}</span>
        </div>
      }
    </div>
  }

  <!--
    The rows in a group of their own, so a heading kept in view can sit outside the box that
    scrolls — a scrollbar always spans the whole of its box, and a heading left inside it would
    be flanked by one. The rowgroup role is what a tbody is: a grid may own its rows through one.
  -->
  <div
    #rowGroup
    role="rowgroup"
    [class]="bodyClasses()"
    [style.max-height]="bodyHeight()"
    [style.scroll-padding-top.px]="bandPadding()">
    @for (group of groups(); track group.key) {
      <div role="none" [class]="groupClasses">
        @if (group.section; as section) {
          <div #band ngGridRow [class]="sectionRowClasses()" [attr.data-mib-section]="section.label">
            <div ngGridCell role="rowheader" [colSpan]="columns().length" [class]="sectionCellClasses">
              <span class="flex min-w-0 flex-wrap items-baseline gap-x-3">
                <span class="text-base font-semibold text-mib-branding-900">{{ section.label }}</span>
                @if (section.description; as description) {
                  <span class="text-xs/4.5 text-gray-500">{{ description }}</span>
                }
              </span>
              @if (sectionEnd(); as end) {
                <span class="ms-auto flex shrink-0 items-center ps-3">
                  <ng-container
                    [ngTemplateOutlet]="end.template"
                    [ngTemplateOutletContext]="{ $implicit: section }"
                    ngTemplateOutletInjector="outlet" />
                </span>
              }
            </div>
          </div>
        }
        @for (entry of group.rows; track entry.key) {
          @let row = entry.row;
          <div
            ngGridRow
            mibClipped
            #rowTip="mibClipped"
            [class]="rowClassesOf(row)"
            [mibTooltip]="rowTip.clipped()"
            [mibTooltipShowDelay]="tooltipDelay">
            @for (column of columns(); track $index; let first = $first) {
              <div ngGridCell #cell="ngGridCell" [class]="cellClasses(column)" [disabled]="cellDisabled(row, cell)">
                @if (first && href(row); as address) {
                  <!--
                    One anchor the size of the row, holding no text of its own: what names it is the
                    field the page pointed at. It sits in the first cell so the arrow keys reach it
                    as they reach any control of the table, and it covers the row because the row is
                    the positioned ancestor. Everything pressable in a cell is raised above it.
                  -->
                  <a
                    ngGridCellWidget
                    [href]="address"
                    [attr.target]="rowLink()?.target ?? null"
                    [attr.aria-label]="name(row)"
                    [class]="rowLinkClasses"
                    (click)="open(row, $event)"></a>
                }
                @if (templates()[column.key]; as template) {
                  <!--
                    The injector is taken from where the view lands and not from where the page
                    declared the template, or a control inside a cell would never find the grid
                    above it.
                  -->
                  <ng-container
                    [ngTemplateOutlet]="template"
                    [ngTemplateOutletContext]="{ $implicit: row }"
                    ngTemplateOutletInjector="outlet" />
                } @else {
                  <span>{{ text(row, column) }}</span>
                }
              </div>
            }
          </div>
        }
      </div>
    }

    @if (rows().length === 0) {
      <p [class]="emptyClasses">{{ emptyLabel() }}</p>
    }
  </div>
</div>
